/*
  Drapers — Cart age acknowledgement.
  Disables the checkout button(s) until the shopper ticks the 18+ box in the
  cart. State is kept for the session so re-rendering the cart drawer (Dawn
  re-renders it on every quantity change) doesn't lose the confirmation.
  Progressive enhancement: with JS off, checkout is never blocked here — the
  entry age gate and per-product notices still apply.
*/
(function () {
  var STATE_KEY = 'drapers_age_ack';

  function saved() {
    try { return sessionStorage.getItem(STATE_KEY) === '1'; } catch (e) { return false; }
  }
  function save(v) {
    try { sessionStorage.setItem(STATE_KEY, v ? '1' : '0'); } catch (e) {}
  }

  function sync() {
    var acks = document.querySelectorAll('.drapers-cart-ack__input');
    if (!acks.length) return;
    var ok = saved();

    acks.forEach(function (cb) {
      if (cb.checked !== ok) cb.checked = ok;
      var box = cb.closest('.drapers-cart-ack');
      if (box) box.classList.toggle('is-required', !ok);
    });

    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      if (!ok) {
        if (!btn.disabled) {
          btn.disabled = true;
          btn.setAttribute('data-age-disabled', 'true');
        }
      } else if (btn.getAttribute('data-age-disabled')) {
        btn.disabled = false;
        btn.removeAttribute('data-age-disabled');
      }
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.classList.toggle('drapers-ack-blocked', !ok);
    });
  }

  // Delegated change handler survives cart drawer re-renders
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('.drapers-cart-ack__input');
    if (!cb) return;
    save(cb.checked);
    sync();
  });

  // Re-apply state whenever a cart container re-renders
  var debounce;
  var observer = new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(sync, 60);
  });
  function observe() {
    ['cart-drawer', '#main-cart-footer', '#main-cart-items', '.cart__footer'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (node) {
        observer.observe(node, { childList: true, subtree: true });
      });
    });
  }

  function init() { observe(); sync(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
